import React from 'react'
import { Form, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
/**
 * @prop config 属性设置
 */
export default class TempVideo extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { config } = this.props;
        return (
            <Form.Item label={config.title} name={config.field}>
                <Upload {...config.props} listType="picture-card">
                    <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>上传视频</div>
                    </div>
                </Upload>
            </Form.Item>
        )
    }
}
